
import { Vue, Component } from 'vue-property-decorator'
import { Mutation, Getter, State } from 'vuex-class'
import HeaderNav from '@/components/header-nav.vue'
import apis from '@/const/apis'
import axios from '@/utils/axios'
import request from '@/utils/request'
import {
  SET_CREDIT_INFO,
} from '@/store/types'
import {
  TaxRateMap,
  TeaConfigPayment
} from '@/const/payment'
import { percentileDivisionFormatMoney } from '@/mixins/currencyMixin'
import { getLang } from '@/utils/unicodeUtil'
import { getRiskInfo } from '@/utils/tool'
import { getAbVersionByName, LibraTestName, LibraTestAbVersionResult } from '@/AbtestVersion'
import { domainTTP, PAYMENT_SCENE } from '@/const/common'

@Component({
  name: 'Checkout',
  components: {
    HeaderNav
  }
})
export default class Checkout extends Vue {
  @Mutation(`payment/${SET_CREDIT_INFO}`) setCreditInfo: Function
  @Mutation('SET_PAYNOW_ABTEST') setPaynowAbtest: any
  @Getter('payment/creditInfo') creditInfo: any
  @State('payNowABTest') payNowABTest: any

  // 账单\总金额=balance+tax
  get amount(): number {
    const amount = Number(this.creditInfo?.amount ?? '')
    return !isNaN(amount) ? amount : 0
  }
  get formatedAmount(): string {
    return percentileDivisionFormatMoney(this.amount)
  }
  // 当前使用的货币
  get currency(): string {
    return this.creditInfo?.currency ?? ''
  }
  // 账单\总消耗   不含税
  get balance(): number {
    const balance = Number(this.creditInfo?.balance ?? '')
    return !isNaN(balance) ? balance : 0
  }
  get formatedBalance(): string {
    return percentileDivisionFormatMoney(this.balance)
  }
  // 账单\总税费
  get tax(): number {
    const tax = Number(this.creditInfo?.tax ?? '')
    return !isNaN(tax) ? tax : 0
  }
  get formatedTax(): string {
    return percentileDivisionFormatMoney(this.tax)
  }
  // 税名称及数额
  get taxDetail(): { key: string; value: string }[] {
    let taxDetail = []
    for (let [key, value] of Object.entries(this.creditInfo?.tax_detail ?? {})) {
      let num = Number(value)
      if (isNaN(num)) {
        num = 0
      }
      taxDetail.push({
        key: key,
        value: percentileDivisionFormatMoney(num)
      })
    }
    return taxDetail
  }
  // 税名称及比例
  get taxRate(): TaxRateMap {
    return this.creditInfo?.tax_rate_map ?? {}
  }
  // 手动支付
  get payDeductUrl(): string {
    return this.creditInfo?.pay_deduct_url ?? ''
  }
  get queryParam(): string {
    return `&language=${getLang()}&redirect=${encodeURIComponent('/wap/credit_purchase')}`
  }

  created() {
    this.initData()
  }

  async initData() {
    // 获取 credit info
    if (!this.payNowABTest.load) {
      try {
        const result = await getAbVersionByName(LibraTestName.PAYNOW_API);
        this.setPaynowAbtest(result?.group === LibraTestAbVersionResult.treatment);
      } catch (e) {
        this.setPaynowAbtest(false);
      }
    }
    if (!this.payNowABTest.isAbTest) {
      axios.get(apis.payment.getCreditInfo).then(res => {
        let { data = {} } = (res || {})
        this.setCreditInfo(data)
      })
    } else {
      if(!this.creditInfo?.invoice_id || !this.creditInfo?.invoice_id?.length) {
        const currentDomain = window.location.host;
        const scene = currentDomain === domainTTP ? PAYMENT_SCENE.TTP_MOBILE : PAYMENT_SCENE.DEFAULT;
        Promise.all([axios.get(apis.payment.getCreditInfo), axios.post(apis.payment.getUnpaidInvoice, { ad_channel: 'TTAM_MOBILE_LITE', ...getRiskInfo(), scene })])
        .then(res => {
          let [{ data: creditInfo = {} }, { data: unpaidInfo = {} }] = (res || [{}, {}]);
          request.post(apis.payment.getPaynowUrl, { invoice_id: unpaidInfo?.invoice_entity?.invoice_id_list, ad_channel: 'TTAM_MOBILE_LITE', ...getRiskInfo(), scene }).then(response => {
            const { data: { pay_now_url = ''} } = response;
            const data = {
              ...creditInfo,
              tax_detail: JSON.parse(unpaidInfo?.invoice_entity?.tax_detail_map || '{}'),
              amount: unpaidInfo?.invoice_entity?.unpaid_amount,
              balance: unpaidInfo?.invoice_entity?.unpaid_amount_without_tax,
              tax_rate_map: JSON.parse(unpaidInfo?.invoice_entity?.tax_rate_map || '{}'),
              status: unpaidInfo?.invoice_entity?.status,
              tax: unpaidInfo?.invoice_entity?.unpaid_total_tax_amount,
              currency: unpaidInfo?.invoice_entity?.currency,
              pay_deduct_url: pay_now_url
            };
            this.setCreditInfo(data);
          })
        })
      } else {
        request.post(apis.payment.getPaynowUrl, { invoice_id: this.creditInfo?.invoice_id, ad_channel: 'TTAM_MOBILE_LITE', ...getRiskInfo() }).then(response => {
          const { data: { pay_now_url = ''} } = response;
          this.setCreditInfo({ ...this.creditInfo, pay_deduct_url: pay_now_url})
        })
      }
    }
  }
  onPurchase() {
    this.$trackEvent(TeaConfigPayment.payment_lite_autopay_make_payment_lite_continue)
    window.location.href = `${this.payDeductUrl}${this.queryParam}`
  }
  goBack() {
    this.$trackEvent(TeaConfigPayment.payment_lite_autopay_make_payment_lite_cancel)
    this.$router.back()
  }
}
